import { Component, Input, OnInit, Output, EventEmitter, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Note } from '../../generated/interfaces';
import { tap, map } from 'rxjs/operators';
import { Observable, Subscription } from 'rxjs';
import { AbstractNoteService } from '../abstract-note.service';

@Component({
  selector: 'messaging-service-note-edit',
  templateUrl: './note-edit.component.html',
  styleUrls: ['./note-edit.component.scss']
})
export class NoteEditComponent implements OnInit, OnDestroy {
  note: Note;
  text: string;

  autosave = false;

  private subscriptions: Subscription[] = [];

  @Output()
  onSave = new EventEmitter<Note>();

  @Output()
  onSaveAsDraft = new EventEmitter<Note>();

  private savingInProgress = false;
  private noteSnapshot: string;
  private _showDraft = false;

  constructor(private route: ActivatedRoute, private noteService: AbstractNoteService) { }

  ngOnInit() {
    this.subscriptions.push(
      this.route.data.pipe(map((data: { note: Note }) => data.note))
        .subscribe(note => this.updateCurrentNote(note)),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(element => element.unsubscribe());
  }


  save() {
    this.savingInProgress = true;

    this.noteService.save(this.note, this.text)
      .subscribe(saved => this.afterSave(saved));
  }

  onAutosave() {
    if (!this.autosave || this.savingInProgress) {
      return;
    }

    if (this.text === this.noteSnapshot) {
      return;
    }

    this.noteService.saveAsDraft(this.note, this.text)
      .subscribe(saved => this.afterSaveAsDraft(saved));
  }

  set showDraft(value: boolean) {
    if (this.note.draft === null) {
      value = false;
    }

    if (value) {
      this.text = this.note.draft;
    } else {
      this.text = this.note.text;
    }

    this._showDraft = value;
  }

  get showDraft() {
    return this._showDraft;
  }

  private afterSave(note: Note) {
    this.updateCurrentNote(note);
    this.onSave.emit(note);
    this.savingInProgress = false;
  }

  private afterSaveAsDraft(note: Note) {
    this.updateCurrentNote(note);
    this.onSaveAsDraft.emit(note);
  }

  private updateCurrentNote(note: Note) {
    this.note = note;

    if (note.draft === null) {
      this.text = note.text;
      this.noteSnapshot = note.text;
      this.showDraft = false;
    } else {
      this.text = note.draft;
      this.noteSnapshot = note.draft;
      this.showDraft = true;
    }
  }
}
